var render, staticRenderFns
import script from "./InjectConstants.vue?vue&type=script&lang=ts&"
export * from "./InjectConstants.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports